import React from 'react';
import { Button as MuiButton } from '@mui/material';

const Button = ({ variant = 'primary', children, ...props }) => {
  const getButtonStyles = () => {
    switch (variant) {
      case 'primary':
        // Blue background with white text
        return {
          bgcolor: '#4D9FE6',
          color: 'white',
          '&:hover': {
            bgcolor: '#0b5ed7',
          },
          border: 'none',
        };
      case 'secondary':
        // White background with blue border and text
        return {
          bgcolor: 'white',
          color: '#0D6EFD',
          border: '1px solid #0D6EFD',
          '&:hover': {
            bgcolor: 'rgba(13, 110, 253, 0.04)',
          },
        };
      case 'light':
        // Light blue background with blue text
        return {
          bgcolor: ' #E8F1FF',
          color: ' #0D6EFD',
          border: 'none',
          '&:hover': {
            bgcolor: '#d8e7ff',
          },
        };
      case 'dark':
        // Dark blue background with white text
        return {
          bgcolor: ' #0A4BB7',
          color: 'white',
          border: 'none',
          '&:hover': {
            bgcolor: '#083d96',
          },
        };
      default:
        return {};
    }
  };

  return (
    <MuiButton
      {...props}
      size='large'
      sx={{
        textTransform: 'none',
        borderRadius: '10px',
        py: 1,
        px: 4,
        fontWeight: 500,
        ...getButtonStyles(),
        ...props.sx,
      }}
    >
      {children}
    </MuiButton>
  );
};

export default Button; 